<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName ">History changes</div>
                <div class="col-sm-12 col-md-5">

                </div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter mt-3">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-2"
                    >
                      <input
                        class="form-control borderNone form-control-sm mr-3"
                        v-model="search"
                        v-on:keyup="filterResults()"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              
              <div class="row filterbystatus">
                <div class="col-sm-12 col-md-2 mt-1 text-left heading">
                  Filter by status:
                </div>
                <div class="col-sm-12 col-md-5 mt-1 text-left">
                  <input
                    type="checkbox"
                    id="create_action"
                    value="1"
                    v-model="filterAction"
                    v-on:change="filterResults()"
                  />
                  <label for="create_action">Create</label>
                  <input
                    type="checkbox"
                    id="update_action"
                    value="2"
                    v-model="filterAction"
                    v-on:change="filterResults()"
                  />
                  <label for="update_action">Update</label>
                  <input
                    type="checkbox"
                    id="delete_action"
                    value="3"
                    v-model="filterAction"
                    v-on:change="filterResults()"
                  />
                  <label for="delete_action">Delete</label>
                </div>
                <div class="col-sm-12 col-md-5 mt-1 text-right heading clearFilter" type="reset">
                  <button  @click="ClearFilters()">Clear filters</button>
              </div>
              </div>
              
                 <div v-show="hover" class="auditDetailsBackground">
                 <div v-if="auditDetailsInfoStatus && !voucherStats">{{auditDetailsEmptyMsg}}</div>
                 <div v-if="voucherStats">
                 <h5>Imports of voucher codes for {{vouchersDetails.provider_name}} - {{vouchersDetails.voucher_name}}</h5>
                 <table   id="datatable"
                      class="table table-striped table-bordered dataTable dtr-inline auditDetailsTable"
                      cellspacing="0"
                      width="100%"
                      role="grid"
                      aria-describedby="datatable_info"
                      style="width: 100%;">
                    <thead>
                       <tr role="row">
                          <th>{{this.vouchersDetails.column1}}</th>
                          <th>{{this.vouchersDetails.column2}}</th>
                          <th>{{this.vouchersDetails.column3}}</th>
                          <th>{{this.vouchersDetails.column4}}</th>
                        </tr>
                    </thead>

                      <tbody>
                              <tr  v-for="item in vouchersDetails.rows" :key="item.id" role="row">                                                 
                                <td >{{vouchersDetails.success[item-1]}}</td>
                                <td >{{vouchersDetails.edited[item-1]}}</td>
                                <td >{{vouchersDetails.failed[item-1]}}</td>
                                <td >{{vouchersDetails.freed[item-1]}}</td>
                          </tr>
                        
                      </tbody>
                 </table>
                 </div>
                <div v-if="newBrandStats && !auditDetailsInfoStatus && !voucherStats">
                    <!-- <h5>Imports of voucher codes for {{vouchersDetails.provider_name}} - {{vouchersDetails.voucher_name}}</h5> -->
                    <table   id="datatable"
                      class="table table-striped table-bordered dataTable dtr-inline auditDetailsTable"
                      cellspacing="0"
                      width="100%"
                      role="grid"
                      aria-describedby="datatable_info"
                      style="width: 100%;">
                    <thead>
                       <tr role="row">
                          <th>{{this.brandsDetails.column1}}</th>
                          <th>{{this.brandsDetails.column2}}</th>
                          <th>{{this.brandsDetails.column3}}</th>
                        </tr>
                    </thead>

                      <tbody>
                          <tr role="row">                                                 
                            <td v-for="item in brandsDetails.data" :key="item.id">{{item}}
                            </td>                        
                        </tr>  
                        
                      </tbody>
                 </table>
                 </div>
                    <div  v-if="!auditDetailsInfoStatus && !voucherStats && !newBrandStats" class="row justify-content-center">                  
                    <table
                      id="datatable"
                      class="table table-striped table-bordered dataTable dtr-inline auditDetailsTable"
                      cellspacing="0"
                      width="100%"
                      role="grid"
                      aria-describedby="datatable_info"
                      style="width: 100%;"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_asc"
                            tabindex="0"
                            aria-controls="datatable"
                            rowspan="1"
                            colspan="1"
                            style="width: 229px;"
                            aria-sort="ascending"
                            aria-label="Name: activate to sort column descending"
                          >{{ this.auditDetailsInfo.column1}}</th>
                          <th
                            class="sorting"
                            tabindex="0"
                            aria-controls="datatable"
                            rowspan="1"
                            colspan="1"
                            style="width: 229px;"
                            aria-label="Age: activate to sort column ascending"
                          >{{ this.auditDetailsInfo.column2}}</th>
                          <th
                            class="sorting"
                            tabindex="0"
                            aria-controls="datatable"
                            rowspan="1"
                            colspan="1"
                            style="width: 229px;"
                            aria-label="Age: activate to sort column ascending"
                          >{{ this.auditDetailsInfo.column3}}</th>
                          <th
                            class="sorting"
                            tabindex="0"
                            aria-controls="datatable"
                            rowspan="1"
                            colspan="1"
                            style="width: 229px;"
                            aria-label="Age: activate to sort column ascending"
                          >{{ this.auditDetailsInfo.column4}}</th>
                          <th
                            class="disabled-sorting sorting"
                            tabindex="0"
                            aria-controls="datatable"
                            rowspan="1"
                            colspan="1"
                            style="width: 230px;"
                            aria-label="Actions: activate to sort column ascending"
                          >{{ this.auditDetailsInfo.column5}}</th>
                        </tr>
                      </thead>
                      <tbody>
                              <tr role="row">                                                 
                          <td 
                            v-for="item in auditDetailsInfo.data "  :key="item.id">{{item}}</td>
                                                  
                        </tr>              
                      </tbody>
                    </table>                                   
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%;"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 350px;"
                          aria-sort="ascending"
                          aria-label="Message: activate to sort column descending"
                          v-on:click="sortResults(1)"
                        >Message</th>
                         <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 100px;"
                          aria-label="Action: activate to sort column ascending"
                          v-on:click="sortResults(2)"
                        >Action</th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 120px;"
                          aria-label="Admin: activate to sort column ascending"
                          v-on:click="sortResults(3)"
                        >Modified by</th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 120px;"
                          aria-label="Date: activate to sort column ascending"
                          v-on:click="sortResults(4)"
                        >Date</th>
                           <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 60px;"
                        >Details</th>
                          
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-for="(item, index) in items"
                        :key="item.id"
                        v-bind:class="[(index % 2 ==0 || index==0) ? 'even' : 'odd']"
                      >
                        <td tabindex="0" class="sorting_1">{{ item.message }}</td>
                        <td>{{ item.action_name }}</td>
                        <td>{{ item.adminname? item.adminname : 'Themselves' }}</td>
                        <td>{{ item.createdon }}</td>
                        <td>
                          <i
                            class="far fa-file-alt fa-2x"
                            id="auditDetails"
                            @mouseenter="showDetails(index);"
                            @mouseleave="hover=false"
                            @mouseup="auditDetails = true; hover=false"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination :meta_data="meta_data" v-on:next="fetchResults"></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  
</template>


<script>
import axios from 'axios';
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      hover: false,
      auditDetails: false,
      voucherStats: false,
      newBrandStats: false,
      vouchersDetails: [],
      brandsDetails: [],
      errorMsg: "",
      items: [],
      auditDetailsInfo: [],
      filterAction: [],
      auditDetailsInfoStatus: false,
      auditDetailsEmptyMsg: "",
      search: null,
      order: null,
      sort: null,
      id: null,
      dir: 0,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
    };
  },
  mounted() {
    this.fetchResults(
      this.meta_data.current_page,
      this.meta_data.perpage,
      this.search,
      this.order,
      this.sort,
      this.filterAction,
      this.meta_data.total
    );
  },
  methods: {
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) this.sort = "desc";
      else this.sort = "asc";
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort,
        this.filterAction,
        this.meta_data.total
      );
    },
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      order = this.order,
      sort = this.sort,
      action = this.filterAction,
      total = this.meta_data.total
    ) {
      console.log(this.filterAction);
      axios
        .get(store.state.BASE_URI + "admin/audit/audit", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            action,
            total,
          },
        })
        .then((res) => {
          console.log(res.data);

          this.results = res.data.results.items;
          this.items = res.data.results.items;
          this.results.forEach((value, index) => {
            var content = JSON.parse(value.content);
            var id = value.id;
            if (value.action == 1) this.items[index].action_name = "created";
            else if (value.action == 2)
              this.items[index].action_name = "updated";
            else if (value.action == 3)
              this.items[index].action_name = "deleted";

            this.items[index].message = content.message;
            this.items[index].details = content.summary;
            console.log(this.items[index]);
          });
          var pagination = res.data.results.pagination;
          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.total = pagination.total;
        });
    },
    showDetails(id = null) {
      this.hover = true;
      console.log(this.items);
      if (this.items[id].details !== null) {
        var htabele = this.items[id].history_table;

        if (htabele == "brand_packs") {
          this.voucherStats = false;
          this.auditDetailsInfo = [];
          this.auditDetailsInfo.data = [];
          this.auditDetailsInfo.column1 = "Brand";
          this.auditDetailsInfo.column2 = "Packaging";
          this.auditDetailsInfo.column3 = "Size";
          this.auditDetailsInfo.column4 = "Points";
          this.auditDetailsInfo.column5 = "Updated by";
          this.auditDetailsInfo.data.push(this.items[id].details[0].brand_name);
          this.auditDetailsInfo.data.push(this.items[id].details[0].name);
          this.auditDetailsInfo.data.push(this.items[id].details[0].size);
          this.auditDetailsInfo.data.push(
            this.items[id].details[0].greenpoints
          );
          this.auditDetailsInfo.data.push(this.items[id].adminname);
        } else if (htabele == "vouchers") {
          console.log(id);
          this.auditDetailsInfo = [];
          this.vouchersDetails = [];
          var rows = 0;
          this.vouchersDetails.success = [];
          this.vouchersDetails.provider_name =
            this.items[id].details["provider_name"];
          this.vouchersDetails.voucher_name =
            this.items[id].details["voucher_type_name"];
          this.vouchersDetails.column1 = "New vouchers";
          this.vouchersDetails.column2 = "Updated vouchers";
          this.vouchersDetails.column3 = "Failed vouchers";
          this.vouchersDetails.column4 = "Freed vouchers";
          this.vouchersDetails.success = this.items[id].details["success"];
          this.vouchersDetails.failed = this.items[id].details["failed"];
          this.vouchersDetails.edited = this.items[id].details["edited"];
          this.vouchersDetails.freed = this.items[id].details["freed"]
            ? this.items[id].details["freed"]
            : [];

          rows = Math.max(
            this.vouchersDetails.success.length,
            this.vouchersDetails.failed.length,
            this.vouchersDetails.edited.length,
            this.vouchersDetails.freed ? this.vouchersDetails.freed.length : 0
          );

          this.voucherStats = true;
          this.vouchersDetails.rows = rows;
          console.log(this.vouchersDetails);
        } else if (htabele == "users") {
          this.voucherStats = false;
          console.log(this.items[id]);
          var status = "";
          this.auditDetailsInfo = [];
          this.auditDetailsInfo.data = [];
          // this.auditDetailsInfo.column1 = "First Name";
          // this.auditDetailsInfo.column2 = "Last Name";
          this.auditDetailsInfo.column1 = "User Name";
          this.auditDetailsInfo.column2 = "Email";
          this.auditDetailsInfo.column3 = "Status";
          this.auditDetailsInfo.column4 = "Updated by";
          this.auditDetailsInfo.column5 = "Date";
          if (this.items[id].details[0].status == 0) status = "Not active";
          else if (this.items[id].details[0].status == 1) status = "Active";
          else status = "Banned";
          this.auditDetailsInfo.data.push(this.items[id].details[0].username);
          // this.auditDetailsInfo.data.push(this.items[id].details[0].lastname);
          this.auditDetailsInfo.data.push(this.items[id].details[0].email);
          this.auditDetailsInfo.data.push(status);
          this.auditDetailsInfo.data.push(this.items[id].adminname);
          this.auditDetailsInfo.data.push(this.items[id].createdon);
        } else if (htabele == "machines") {
          this.voucherStats = false;
          this.auditDetailsInfo = [];
          this.auditDetailsInfo.data = [];
          this.auditDetailsInfo.column1 = "Machine name";
          this.auditDetailsInfo.column2 = "Location";
          this.auditDetailsInfo.column3 = "IP address";
          this.auditDetailsInfo.column4 = "Description";
          this.auditDetailsInfo.column5 = "Updated by";
          this.auditDetailsInfo.data.push(this.items[id].details[0].name);
          this.auditDetailsInfo.data.push(this.items[id].details[0].location);
          this.auditDetailsInfo.data.push(this.items[id].details[0].ip_address);
          this.auditDetailsInfo.data.push(
            this.items[id].details[0].description
          );
          this.auditDetailsInfo.data.push(this.items[id].adminname);
        } else if (htabele == "brands") {
          if (this.items[id].action == 1) {
            this.voucherStats = false;
            this.auditDetailsInfo = [];
            this.brandsDetails = [];
            this.brandsDetails.data = [];
            this.brandsDetails.column1 = "New brand name";
            this.brandsDetails.column2 = "New brand code";
            this.brandsDetails.column3 = "Date";
            this.brandsDetails.data.push(this.items[id].details[0].name);
            this.brandsDetails.data.push(this.items[id].details[0].code);
            this.brandsDetails.data.push(
              this.items[id].details[0].syncmodifiedon
            );
            this.newBrandStats = true;
          } else if (this.items[id].action == 3) {
            this.voucherStats = false;
            this.auditDetailsInfo = [];
            this.brandsDetails = [];
            this.brandsDetails.data = [];
            this.brandsDetails.column1 = "Brand name";
            this.brandsDetails.column2 = "Brand code";
            this.brandsDetails.column3 = "Date";
            this.brandsDetails.data.push(this.items[id].details[0].name);
            this.brandsDetails.data.push(this.items[id].details[0].code);
            this.brandsDetails.data.push(
              this.items[id].details[0].syncmodifiedon
            );
            this.newBrandStats = true;
          } else {
            this.newBrandStats = false;
            this.voucherStats = false;
            this.auditDetailsInfo = [];
            this.auditDetailsInfo.data = [];
            this.auditDetailsInfo.column1 = "Old Name";
            this.auditDetailsInfo.column2 = "Old Code";
            this.auditDetailsInfo.column3 = "New Name";
            this.auditDetailsInfo.column4 = "New Code";
            this.auditDetailsInfo.column5 = "Date";

            this.auditDetailsInfo.data.push(this.items[id].details.oldName);
            this.auditDetailsInfo.data.push(this.items[id].details.oldCode);
            this.auditDetailsInfo.data.push(this.items[id].details.newName);
            this.auditDetailsInfo.data.push(this.items[id].details.newCode);
            this.auditDetailsInfo.data.push(this.items[id].details.date);
          }
        }

        // this.auditDetails = this.items[id].details;
        this.auditDetailsInfoStatus = false;
        this.auditDetailsEmptyMsg = "";
      } else {
        this.auditDetailsInfo.data = [];
        this.auditDetailsInfo = [];
        this.auditDetailsInfoStatus = true;
        this.auditDetailsEmptyMsg = "No details for this record";
      }
    },
    filterResults() {
      this.meta_data.current_page = 1;
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort,
        this.filterAction
      );
    },
    ClearFilters() {
      this.meta_data.current_page = 1,
      this.meta_data.perpage = 5,
      this.search = null,
      this.order =null,
      this.sort = null,
      this.filterAction = null,
      this.meta_data.total = 0,
        this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort,
        this.filterAction,
        this.meta_data.total
    );
  
  },
  },
};
</script>

<style src="../css/style.css"></style>